export default {
  '学年学期管理':'学年学期管理',
  '至':'至',
  '新增学年':'新增学年',
  '秋季学期':'秋季学期',
  '春季学期':'春季学期',
  '寒假':'寒假',
  '暑假':'暑假',
  '是否删除{year}学年学期？':'是否删除{year}学年学期？',
  '编辑学年':'编辑学年',
  '学期时间':'学期时间',
  '入学年份管理':'入学年份管理',
  '学段':'学段',
  '毕业状态':'毕业状态',
  '当前年级':'当前年级',
  '入学年份':'入学年份',
  '新增入学年份':'新增入学年份',
  '编辑入学年份':'编辑入学年份',
  '是否删除{gradeName}？':'是否删除{gradeName}？',
  '入学年份删除成功':'入学年份删除成功',
  '新增入学年份成功':'新增入学年份成功',
  '班级管理':'班级管理',
  '新增班级':'新增班级',
  '班级码':'班级码',
  '班级导入模板':'班级导入模板',
  '批量新增班级':'批量新增班级',
  '所属学级':'所属学级',
  '当前年级':'当前年级',
  '班级名称':'班级名称',
  '班级编号':'班级编号',
  '班级人数':'班级人数',
  '编辑班级':'编辑班级',
  '新增班级成功':'新增班级成功',
  '编辑班级成功':'编辑班级成功',
  '是否批量删除所选班级？':'是否批量删除所选班级？',
  '请勾选要删除的班级':'请勾选要删除的班级',
  '是否删除班级{classFullName}？':'是否删除班级{classFullName}？',
  '导入班级时关联教师信息，可以在导入时一并创建教师角色':'导入班级时关联教师信息，可以在导入时一并创建教师角色',
  '所属学级不能为空':'所属学级不能为空',
  '更多班号':'更多班号',
  '班级编码':'班级编码',
  '教师姓名':'教师姓名',
  '根据所选编号区间，批量生成班级，已有编号自动跳过':'根据所选编号区间，批量生成班级，已有编号自动跳过',
  '新增年级':'新增年级',
  '班级编码不能为空':'班级编码不能为空',
  '班级编码范围有误':'班级编码范围有误',
  '班级编码不超过99':'班级编码不超过99',
  '班级导出':'班级导出',
  '院系导出':'院系导出',
  '专业导出':'专业导出',
  '机构列表':'机构列表',
  '请输入机构名\机构代码':'请输入机构名\机构代码',
  '新增机构':'新增机构',
  '设备激活码':'设备激活码',
  '重置激活码':'重置激活码',
  '可激活设备数量':'可激活设备数量',
  '已激活设备':'已激活设备',
  '机构名称':'机构名称',
  '机构代码':'机构代码',
  '上级机构':'上级机构',
  '系统管理员':'系统管理员',
  '确认要删除该机构：{orgName}？':'确认要删除该机构：{orgName}？',
  '可激活数量必须大于已激活数量。':'可激活数量必须大于已激活数量。',
  '上级机构名称':'上级机构名称',
  '管理员密码':'管理员密码',
  '编辑机构':'编辑机构',
  '密码不能少于6位':'密码不能少于6位',
  '密码不能多于20位':'密码不能多于20位',
  '系统管理员{newVal}':'系统管理员{newVal}',
  '院系':'院系',
  '专业':'专业',
  '根据班级名称模糊查询':'根据班级名称模糊查询',
  '批量添加':'批量添加',
  '院系管理':'院系管理',
  '根据名称或代码搜索':'根据名称或代码搜索',
  '批量新增院系':'批量新增院系',
  '院系名称':'院系名称',
  '院系代码':'院系代码',
  '上级组织':'上级组织',
  '编辑院系':'编辑院系',
  '请输入两位数字代码':'请输入两位数字代码',
  '新增院系':'新增院系',
  '专业管理':'专业管理',
  '根据专业、院系名称或代码搜索':'根据专业、院系名称或代码搜索',
  '批量新增专业':'批量新增专业',
  '专业名称':'专业名称',
  '专业代码':'专业代码',
  '所属院系':'所属院系',
  '所属院系代码':'所属院系代码',
  '学制':'学制',
  '请选择修学年限':'请选择修学年限',
  '新增专业':'新增专业',
  '编辑专业':'编辑专业',
  '请选择添加范围':'请选择添加范围',
  '请按照模板格式进行导入，':'请按照模板格式进行导入，',
  '点击下载模板':'点击下载模板',
  '点击或将文件拖拽到这里':'点击或将文件拖拽到这里',
  '上传支持':'上传支持',
  '上传中，请稍等':'上传中，请稍等...',
  '创建成功':'创建成功',
  '创建失败':'创建失败',
  '导出失败记录':'导出失败记录',
  '部分数据创建失败，请导出失败记录，修改后重新上传。':'部分数据创建失败，请导出失败记录，修改后重新上传。',
}